import { gql } from "@apollo/client";

export const BALANCE_SHEETS_QUERY = gql`
  query partnerBalanceSheets($partnerId: Int!) {
    partnerBalanceSheets(partnerId: $partnerId) {
      balanceSheetId
      partnerId
      configId
      dimensionYear
      dimensionMonth
      localName
      currencyId
      currencyRate
      finalizationTypeId
      balanceSheetTypeId
      bankId
    }
  }
`;

export const ACCSTATEMENT_CONFIGS_QUERY = gql`
  query accStatementConfigs {
    accStatementConfigs {
      configId
      configName
      configVersion
      activeYN
      bankId
      accStatementConfigDetails {
        configDetailId
        configId
        accountSymbol
        accountName
        accountTypeId
        accountClass
        financialIndicatorId
        orderNo
        visibleYN
        readOnlyYN
      }
    }
  }
`;

export const ACCOUNT_TYPES = gql`
  query accountTypes {
    accountTypes {
      dictionaryItemId
      dictionaryItemCode
      dictionaryItemName
      dictionaryItemDescription
    }
  }
`;

export const BALANCE_SHEET_TYPES = gql`
  query balanceSheetTypes {
    balanceSheetTypes {
      dictionaryItemId
      dictionaryItemCode
      dictionaryItemName
      dictionaryItemDescription
    }
  }
`;

export const FINALIZATION_TYPES = gql`
  query finalizationTypes {
    finalizationTypes {
      dictionaryItemId
      dictionaryItemCode
      dictionaryItemName
      dictionaryItemDescription
    }
  }
`;

export const BALANCE_SHEET_DETAILS_BY_ACCOUNT_CLASS = gql`
  query partnerBalanceSheetDetailsByAccountClass($balanceSheetId: Int!, $accountClass: String!) {
    partnerBalanceSheetDetailsByAccountClass(balanceSheetId: $balanceSheetId, accountClass: $accountClass) {
      balanceSheetDetailId
      balanceSheetId
      configDetailId
      creditCurrencyAmount
      debitCurrencyAmount
      eqCreditAmount
      eqDebitAmount
      accountSymbol
      accountName
      accountTypeId
      accountTypeName
      accountClass
      financialIndicatorId
      orderNo
      readOnlyYN
    }
  }
`;

export const BALANCE_SHEET_ACCOUNT_CLASSES = gql`
  query partnerBalanceSheetAccountClasses($balanceSheetId: Int!) {
    partnerBalanceSheetAccountClasses(balanceSheetId: $balanceSheetId)
  }
`;

export const BALANCE_SHEET_SUMMARY_INFO = gql`
  query partnerBalanceSheetSummaryInfo($balanceSheetId: Int!) {
    partnerBalanceSheetSummaryInfo(balanceSheetId: $balanceSheetId){
      partnerName
      currencyCode
      balanceSheetName
      dimensionYear
      dimensionMonth
    }
  }
`;

export const EXCHANGE_RATE_BY_BANK_ID_AND_DATE = gql`
  query exchangeRateByBankIdAndDate($bankId: Int, $exchangeRateDate: DateTime, $currencyId: Int) {
    exchangeRateByBankIdAndDate(bankId: $bankId, exchangeRateDate: $exchangeRateDate, currencyId: $currencyId) {
      exchangeRateDate
      fromCurrencyId
      fromCurrency
      value
      toCurrencyId
      toCurrency
    }
  }
`;

export const PARTNER_BALANCE_SHEET_INDICATORS = gql`
  query partnerBalanceSheetIndicators($balanceSheetId: Int!) {
    partnerBalanceSheetIndicators(balanceSheetId: $balanceSheetId) {
      balanceSheetIndicatorId
      balanceSheetId
      indicatorId
      indicatorValue
      configId
      orderNo
      code
      name
      attributeName
      expression
      financialIndicatorId
    }
  }
`;